<ng-container [formGroup]="form">
  <div class="hot-search-input-filter">
    <div [attr.data-test-id]="config.testId"
         class="search-input">
      <mat-icon class="search-input_search-icon">search</mat-icon>
      <input [formControlName]="controlName"
             (input)="onInput($event)"
             autocomplete="off"
             class="input"
             [name]="controlName"
             [maxlength]="config.maxLength"
             [placeholder]="config.hotFilter.overlayButtonText"
             type="text"
             [mask]="config.mask"
             (keydown.enter)="searchOnEnter()"
      >
      <button (click)="clearField(control, $event, '')"
              *ngIf="control?.value?.length"
              aria-label="Clear"
              class="p-0 search-input_clear-btn"
              mat-button
              mat-icon-button
              matSuffix>
        <mat-icon>close</mat-icon>
      </button>
      <button
        (click)="applyFilterForm()"
        [disabled]="!control.valid || !isValueChanged"
        type="button"
        class="search-input_search-button"
      >
        {{config.hotFilter.quickButtonText}}
      </button>
    </div>

    <button
      [matTooltip]="!!previousValue ? 'Спочатку очистіть пошук за номером накладної' : ''"
      [disabled]="!!previousValue"
      (click)="openFilters()"
      onclick="this.blur()"
      mat-button
      class="mat-button_with-icon filters-button">
      <mat-icon class="material-icons">tune</mat-icon>
      <span *ngIf="!isMobile">Усі фільтри</span>
    </button>
  </div>

  <mat-error class="search-input_error">{{getError(control, config.errors)}}</mat-error>
</ng-container>
